import type { MessageDescriptor } from 'react-intl';
import { defineMessages, useIntl } from 'react-intl';

import { Ineligible } from '@sorare/core/src/atoms/icons/Ineligible';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';

import { TooltipContent } from '#src/components/card/TooltipContent/index.tsx';

const titleMessages = defineMessages({
  partial: {
    defaultMessage: 'Sorare Pro Partially eligible',
  },
  ineligible: {
    defaultMessage: 'Sorare Pro Ineligible',
  },
});

type Props = {
  partial?: boolean;
  description: MessageDescriptor;
};

export const So5Eligibility = ({ description, partial }: Props) => {
  const { formatMessage } = useIntl();
  const title = partial ? titleMessages.partial : titleMessages.ineligible;

  return (
    <Tooltip title={<TooltipContent title={title} description={description} />}>
      <Ineligible title={formatMessage(title)} blue={partial} size={4} />
    </Tooltip>
  );
};
